<template>
    <div class="page-content page-content--wide">
        <div class="page-content__container">
            <div v-if="uncompletedLearningPaths.length === 0 && !showWatchlists">
                <div class="my-learning-no-results">
                    <img height="200px" :src="require('@/assets/images/my_learning_no_results.png')" alt="" class="no_results__image'"/>
                    <span v-html="$t('LandingPage.my_learning_tab_no_results')"></span>
                </div>
            </div>
            <template>
                <div v-if="uncompletedLearningPaths.length > 0">
                    <SubheaderWithTooltip
                        :title="$t('LandingPage.my_learning_tab_learning_paths_title')"
                        tooltipMessage="LandingPage.my_learning_learning_paths_tool_tip_message"
                        icon="crown"
                    />
                    <CourseCarousel
                        :learningPaths="sortedLearningPaths"
                        theme="dark" />
                </div>
                <div v-else>
                    <SubheaderWithTooltip
                            :title="$t('LandingPage.my_learning_tab_learning_paths_title')"
                            tooltipMessage="LandingPage.my_learning_learning_paths_tool_tip_message"
                        >
                            <template v-slot:icon>
                                <img
                                    class="crown"
                                    :src="require('@/assets/images/learningpaths/learningpath_crown.png')"
                                    alt=""
                                />
                            </template>
                    </SubheaderWithTooltip>
                    <NoResults :text="$t('LandingPage.my_learning_tab_no_learning_paths_results')" :onClick="goToLearningPaths" :buttonLabel="$t('LandingPage.explore_learning_paths')"/>
                </div>
            </template>
            <template v-if="showWatchlists">
                <SubheaderWithTooltip
                        :title="$t('LandingPage.my_learning_tab_study_plans_title')"
                        tooltipMessage="LandingPage.my_learning_study_plans_tool_tip_message"
                    >
                        <template v-slot:icon>
                            <span class="icon-bookmarks"/>
                        </template>
                </SubheaderWithTooltip>
                <div v-for="watchlist in getLimitedWatchLists" :key="watchlist.id">
                    <RecommendedItem :title="watchlist.title">
                        <template #info>
                            <WatchListInfoBox v-if="watchlist" :selectedWatchList="watchlist" rightAlign />
                        </template>
                        <CourseCarousel
                            :courses="watchlist.courses"
                            :collections="watchlist.collections"
                            :learningPaths="watchlist.learningPaths"
                            theme="dark" />
                    </RecommendedItem>
                </div>
                <div class="study-plans-tab__load-more">
                    <TotemButton
                        icon="add"
                        color="primary"
                        @click="loadMore"
                        v-if="limit < visibleWatchlistsWithItems.length"
                        :label="$t('General.load_more')"
                    />
                </div>
            </template>
                <div v-else>
                    <SubheaderWithTooltip :title="$t('LandingPage.my_learning_tab_study_plans_title')"
                        tooltipMessage="LandingPage.my_learning_study_plans_tool_tip_message"
                    >
                        <template v-slot:icon>
                            <span class="icon-bookmarks"/>
                        </template>
                    </SubheaderWithTooltip>
                    <NoResults :onClick="goToStudyPlans" :text="$t('LandingPage.my_learning_tab_no_study_plans_results')" :buttonLabel="$t('LandingPage.study_plans_tab_manage_study_plans_button')"/>
                </div>
            </div>
        </div>
</template>

<script>

    import { mapGetters } from 'vuex'
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import SubheaderWithTooltip from 'components/landingpage/SubheaderWithTooltip'
    import CourseCarousel from 'components/landingpage/CourseCarousel'
    import WatchListInfoBox from 'components/user/watchlist/WatchListInfoBox'
    import NoResults from 'components/landingpage/NoResults.vue'

    export default {
        name: 'MyLearning',
        components: { CourseCarousel, RecommendedItem, WatchListInfoBox, SubheaderWithTooltip, NoResults },
        data () {
            return {
                limit: 10
            }
        },
        computed: {
            ...mapGetters({
                watchlists: 'Watchlists/getWatchLists',
                uncompletedLearningPaths: 'LearningPaths/getUncompletedLearningPaths'
            }),
            visibleWatchlistsWithItems () {
                return this.watchlists.filter(watchlist => !watchlist.isHidden && (watchlist.courses.length + watchlist.collections.length + watchlist.learningPaths.length) > 0)
            },
            getLimitedWatchLists () {
                return this.visibleWatchlistsWithItems.filter((el, index) => index < this.limit)
            },
            showWatchlists () {
                return this.visibleWatchlistsWithItems.length > 0
            },
            sortedLearningPaths () {
                return [...this.uncompletedLearningPaths].sort((a, b) => {
                    return b.progressPercentage - a.progressPercentage
                })
            }
        },
        methods: {
            goToStudyPlans () {
                this.$router.push({ name: 'user-watchlist' })
            },
            goToLearningPaths () {
                this.$router.push({ name: 'learning-paths' })
            },
            loadMore () {
                this.limit += 10
            }

        }
    }
</script>

<style lang="scss" scoped>
    .page-content {
        &--wide {
            padding: 0;
        }

        .crown {
            font-size: 2.5rem;
        }

        .icon-bookmarks {
            font-size: 2.0rem;
        }
    }

    .my-learning-no-results {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 30px;
        span {
            font-size: 2rem;
            font-family: 'Quicksand-Regular', sans-serif;
        }
    }

    .study-plans-tab {
        &__text {
            padding: 4rem 0;
            max-width: 800px;
            text-align: center;
            margin: 0 auto;
        }

        &__button-container {
            padding-bottom: 2.5rem;
            width: 100%;
            display: flex;
            justify-content: center;

            &.no-watchlists {
                margin: 0 0 4rem;
            }
        }

        &__button {
            min-height: 50px;
        }

        &__bookmark-icon {
            display: block;
            font-size: 6rem;
            color: $quill_gray;
            margin: 0 0 4rem;
        }

        &__load-more {
            margin: 0 0 60px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>
